import { Component, Inject, OnInit } from "@angular/core";
import { LoadingService } from "@coso/loading";
import { IS_SAAS } from "@coso/utility";
import { Observable } from "rxjs/internal/Observable";
import { GroupStorage, IConfigurationHolder } from "../../../models/auto-generated";
import { SettingsStore } from "../../../stores/settings.store";
import { map } from 'rxjs/operators';

@Component({
  standalone:false,
  templateUrl: "./microsoft-teams.component.html",
  styleUrls: ["./microsoft-teams.component.scss"]
})
export class MicrosoftTeamsComponent implements OnInit {
  GroupStorage = GroupStorage;
  settings$: Observable<IConfigurationHolder>;
  readonly$: Observable<boolean>;
  hasValidGroupStorageForTeams$ : Observable<boolean>;
  
  constructor(@Inject(IS_SAAS) public isSaaS: boolean, public loadingService: LoadingService, private settingsStore: SettingsStore) {}

  ngOnInit(): void {
    this.settings$ = this.settingsStore.settings$;
    this.readonly$ = this.settingsStore.isReadOnly$;
    this.hasValidGroupStorageForTeams$ = this.settings$.pipe(
      map(current => 
      {
        return current?.groupStorage === GroupStorage.ActiveDirectory || current?.groupStorage === GroupStorage.AzureActiveDirectory               
      })
    );
  }

  updateSettings(current: IConfigurationHolder) {
    // resets appendMsTeamsDefaultPermissions when includeMsTeamsDocumentLocations is set to false
    if (!current.includeMsTeamsDocumentLocations) {
      current.appendMsTeamsDefaultPermissions = false;
    }
    this.settingsStore.updateSettings(current);
  }
}
